module.exports = __webpack_public_path__ + "static/media/gf_4.ddd93d89.jpg";